/** Sign-in methods that take typed values (or nothing at all), so the web connects them with a form. */
const FORM_AUTH_TYPES = Object.freeze(['apiKey', 'basic', 'custom', 'none']);

export default FORM_AUTH_TYPES;
